import React from 'react';
import { Button } from 'antd';
import useDownloadDomainOverviewPdf from '../../reportRenderEngine/hooks/useDownloadDomainOverviewPdf';

type Props = {
    websiteGuid: string;
};

export default function DownloadPdfButton({ websiteGuid }: Props) {
    const { downloadPdf, isDownloadingPdf } = useDownloadDomainOverviewPdf();

    return (
        <Button
            className="deep-analysis-small-button"
            size="small"
            disabled={isDownloadingPdf}
            icon={isDownloadingPdf ? 'loading' : 'file-pdf'}
            onClick={() => downloadPdf(websiteGuid)}
        >
            Download PDF
        </Button>
    );
}
